import React from "react";
import { BarChart } from "./BarAndColumnCharts";
import useChartReflow from "../../../../hooks/generic/charts/useChartReflow";

const ChrMeetingRatingReasons = (props) => {
  const { title, chartOptions, chartClasses } = props;
  const { chartWrapperReference, chartCallbackFunction } = useChartReflow();

  return (
    <div className={chartClasses} ref={ chartWrapperReference } tabIndex={0}>
      {
        title &&
        <div className="font-12 font-500">
          {title}
        </div>
      }
      <BarChart
        chartOptions={chartOptions}
        callbackFn={chartCallbackFunction}
      />
    </div>
  );
}

export default ChrMeetingRatingReasons;
